import React from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {PAGE_URLS} from "constants/AppConstants.js";
import {ws} from "styles/tokens";
import BrowserService from "services/BrowserService.js";
import ProfileImageModal from "components/Common/ProfileImageModal";
import {StyleDiv} from "components/Common/StyleDiv";
import {StyleImg} from "components/Common/StyleImg";
import {StyleLink} from "components/Common/StyleLink";
import {useAppUser} from "contexts/AppUserContext";
import {isAndroid} from "FirebaseUtils";

const ProfileImageModalAny: any = ProfileImageModal;

export const APP_NAV_HEIGHT = "70px";

function AppNav() {
  const history = useHistory();
  const {t} = useTranslation();

  const {user} = useAppUser();

  const canShowItems = (user: any) => {
    if (!user) {
      return false;
    } else {
      const url = BrowserService.getPathname();
      return url !== PAGE_URLS.adminPageUrl;
    }
  };

  return (
    <>
      <StyleDiv
        position="sticky"
        top="0"
        zIndex="90000"
        height={APP_NAV_HEIGHT}
        padding="8px 16px 4px"
        backgroundColor={ws.wash}
      >
        <StyleDiv
          height="100%"
          justifyContent="space-between"
          padding="0px 8px 0px 20px"
          boxShadow={ws.shadowSoft}
          gap="8px"
          className="ws-nav app-nav"
        >
          <StyleDiv
            display="flex"
            alignItems="center"
            cursor="pointer"
            className="d-none d-md-flex"
            onClick={() => {
              history.push(PAGE_URLS.diaryPageUrl);
            }}
          >
            <StyleImg className="ws-logo" height="20px" src="/assets/images/waterspeed-logo.svg" alt="Waterspeed" />
          </StyleDiv>
          {canShowItems(user) && (
            <nav className="ws-menu app-nav-menu">
              <AppNavItem href={PAGE_URLS.diaryPageUrl} text={t("nav.activities")} />
              <AppNavItem href={PAGE_URLS.challengesPageUrl} text={t("nav.community")} />
              <AppNavItem
                href={isAndroid ? [PAGE_URLS.aroundMePageUrl, "/"] : PAGE_URLS.aroundMePageUrl}
                text={isAndroid ? t("nav.record") : t("nav.explore")}
              />
              <AppNavItem href={PAGE_URLS.statisticsPageUrl} text={t("nav.statistics")} />
              {!isAndroid && <AppNavItem href={PAGE_URLS.equipmentsPageUrl} text={t("nav.equipment")} />}
            </nav>
          )}
          {canShowItems(user) && (
            <StyleDiv display="flex" flexDirection="row" alignItems="center" gap="6px">
              <ProfileImageModalAny zIndex="90000" />
            </StyleDiv>
          )}
        </StyleDiv>
      </StyleDiv>
    </>
  );
}

function AppNavItem({text, href}: {text: string; href: string | string[]}) {
  const currentUrlPath = BrowserService.getPathname();
  let isHrefIsCurrentPathName;
  if (Array.isArray(href)) {
    isHrefIsCurrentPathName = href.includes(currentUrlPath);
  } else {
    isHrefIsCurrentPathName = currentUrlPath === href;
  }

  return (
    <StyleLink
      to={Array.isArray(href) ? href[0] : href}
      className="ws-nl"
      aria-current={isHrefIsCurrentPathName ? "page" : undefined}
      color={isHrefIsCurrentPathName ? ws.accentText : ws.fg}
      style={{
        whiteSpace: "nowrap",
        fontWeight: isHrefIsCurrentPathName ? 600 : 500,
        background: isHrefIsCurrentPathName ? ws.hover : undefined
      }}
    >
      {text}
    </StyleLink>
  );
}

export default AppNav;
